import React from "react";
import PropTypes from "prop-types";
import getConfig from "next/config";

import Router from "next/router";
import RegionSelect from "@components/Stores/RegionSelect";

const {
  publicRuntimeConfig: {
    content: { websiteTitle },
  },
} = getConfig();

const onUserRegionChange = (regionUrlKey) => {
  if (!regionUrlKey) {
    // If user selected the default regionUrlKey
    // Redirect to stores page
    Router.push("/magazine");
  } else {
    // User didn't select the default regionUrlKey
    // Redirect to selected region
    Router.push(`/magazine/${regionUrlKey}`);
  }
};

const StoresRegionSelect = ({ regions, currentRegion }) => (
  <div className="flex flex-col md:flex-row items-center text-left my-4 -tracking-0.33">
    <p
      className="w-full md:w-auto text-base font-medium text-justify md:mr-3 h-full flex items-center leading-20.8"
      htmlFor="location"
    >
      {`Magazinele ${websiteTitle} din`}
    </p>
    <div className="w-full md:w-1/5 pt-4 md:pt-0">
      <RegionSelect
        handleRegionChange={onUserRegionChange}
        currentRegion={currentRegion}
        regions={regions}
        defaultLabel="Toate regiunile"
        menuPlacement="bottom"
      />
    </div>
  </div>
);

StoresRegionSelect.propTypes = {
  regions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
  currentRegion: PropTypes.string,
};

export default StoresRegionSelect;
